import { createContext } from "react";

interface langType {
    lang: string,
    setLang: Function,
    langs: string[]
}

export const langContext = createContext<langType>({ lang: "nl", setLang: () => { }, langs: [] });
export const agentContext = createContext<Record<string, any>>({});

interface msgCon { message: any, setMessage: Function }
export const messageContext = createContext<msgCon>({ message: null, setMessage: () => { } });